import axios from "axios";

const handleError = (err) => {
  if (err?.response?.status === 401) {
    if (!window.location.href.includes("auth/sign-in")) {
      window.location.href = `/auth/sign-in?returnURL=${window.location.pathname}`;
    }
  } else if (err?.response?.status === 404) {
    window.location.href = "/error/404";
  } else if (err?.response?.status === 400 || err?.response?.status === 422) {
    throw err;
  } else {
    window.location.href = "/error/500";
  }
};

const _endpoint = `/api/auth`;

export const authApi = {
  login: (data) =>
    axios(`${_endpoint}/sign-in`, {
      baseURL: process.env.REACT_APP_API_BASE_URL,
      withCredentials: true,
      method: "post",
      data,
    }).then((result) => result.data),
  logout: () =>
    axios(`${_endpoint}/logout`, {
      baseURL: process.env.REACT_APP_API_BASE_URL,
      withCredentials: true,
      method: "post",
    })
      .then((result) => result.data)
      .catch((err) => handleError(err)),
  validate: () =>
    axios(`${_endpoint}/validate`, {
      baseURL: process.env.REACT_APP_API_BASE_URL,
      withCredentials: true,
      method: "get",
    }).then((result) => result.data),
};
